import React, { useEffect } from 'react';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import '../styles/common/Toast.css';

const ICONS = {
  success: <FaCheckCircle />,
  error: <FaExclamationTriangle />,
};

const TITLES = {
  success: 'Saved',
  error: 'Error',
};

const Toast = ({ title, message, variant = 'success', duration = 3500, onClose }) => {
  useEffect(() => {
    if (!onClose) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  if (!message) return null;

  return (
    <div className="toast-container" role="status" aria-live="polite">
      <div className={`toast toast--${variant}`}>
        <div className="toast-icon">
          {ICONS[variant] || ICONS.success}
        </div>
        <div className="toast-content">
          <div className="toast-title">{title || TITLES[variant] || 'Notice'}</div>
          <div className="toast-message">{message}</div>
        </div>
        <button
          type="button"
          className="toast-close"
          aria-label="Dismiss notification"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
